import { render } from "./MiniSpinner.vue?vue&type=template&id=38a8f891&scoped=true"
import script from "./MiniSpinner.vue?vue&type=script&lang=js"
export * from "./MiniSpinner.vue?vue&type=script&lang=js"

import "./MiniSpinner.vue?vue&type=style&index=0&id=38a8f891&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-38a8f891"
/* hot reload */
if (module.hot) {
  script.__hmrId = "38a8f891"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38a8f891', script)) {
    api.reload('38a8f891', script)
  }
  
  module.hot.accept("./MiniSpinner.vue?vue&type=template&id=38a8f891&scoped=true", () => {
    api.rerender('38a8f891', render)
  })

}

script.__file = "src/icons/components/animated/MiniSpinner.vue"

export default script